import styled, { css } from 'styled-components/macro'
import { device, ColorsMap } from '@/utils/Theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

type StyledProductAreaProps = {
  sizing?: any[]
}
export const StyledProductArea = styled.div<StyledProductAreaProps>`
  width: 100%;
  display: grid;
  justify-items: center;
  position: relative;
  column-gap: 1rem;
  ${(props) => {
    if (props.sizing) {
      return props.sizing.map(
        (size, id) => css`
          @media (min-width: ${size}) {
            grid-template-columns: repeat(${++id}, 1fr);
          }
        `
      )
    }
    return css`
      grid-template-columns: repeat(3, 1fr);
    `
  }}
`

export const BrandWrapper = styled.div`
  position: relative;
  height: 1rem;
  > img {
    height: 100%;
    opacity: 0.5;
    transition: 0.3s;
  }
`

export const ProductBox = styled.div`
  cursor: pointer;
  min-width: 15rem;
  width: 100%;
  margin: 0.5rem auto;
  margin-left: 0;
  background-color: ${ColorsMap.white};
  padding: 1rem;
  @media (max-width: ${device.mobileS}) {
    width: 100%;
    margin: 0.5rem 0;
  }
  &:hover {
    ${BrandWrapper} > img {
      opacity: 1;
    }
  }
  position: relative;
`
export const TagWrapper = styled.div`
  position: absolute;
  top: -0.75rem;
  left: -0.5rem;
`

export const ProductImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 14rem;
  * {
    max-width: 80%;
    height: auto;
    max-height: 100%;
  }
`
export const DescriptionWrapper = styled.div`
  margin: 1rem;
  max-width: 100%;
  * {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`

export const ButtonWrapperLeft = styled.button`
  position: absolute;
  height: 30%;
  top: 50%;
  transform: translate(0, -50%);
  left: 0.2%;
`
export const ButtonWrapperRight = styled.button`
  position: absolute;
  height: 30%;
  top: 50%;
  transform: translate(0, -50%);
  right: 0.2%;
`
export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid;
`

type PaginationWrapperProps = { controller?: boolean }
export const PaginationWrapper = styled.div<PaginationWrapperProps>`
  display: ${(props) => (props.controller ? 'flex' : 'none')};
  color: ${ColorsMap.fontHover};
  margin-top: 1rem;

  @media (max-width: ${device.mobileM}) {
    display: none;
  }
`

export const MobilePaginationWrapper = styled.div<PaginationWrapperProps>`
  display: flex;
  margin: 0 auto;
  margin-top: 1rem;

  @media (min-width: ${device.mobileM}) {
    display: none;
  }
`

type PageNumberProps = { active?: boolean; fluid?: boolean; disabled?: boolean }
export const PageNumber = styled.div<PageNumberProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  cursor: pointer;
  width: ${(props) => (props.fluid ? 'auto' : '2.25rem')};
  height: 2.25rem;
  background-color: ${(props) => {
    if (props.active) {
      return ColorsMap.primary
    }
    if (props.disabled) {
      return 'transparent'
    }
    return ColorsMap.white
  }};
  color: ${(props) => {
    if (props.active) {
      return ColorsMap.white
    }
    if (props.disabled) {
      return ColorsMap.textDefault
    }
    return ColorsMap.black
  }};
  margin: 0 0.25rem;

  @media (max-width: ${device.mobileM}) {
    width: ${(props) => (props.fluid ? 'auto' : '3rem')};
    height: 3rem;
  }
`

export const ShowOrderPart = styled.div<{ activeSlide?: boolean }>`
  width: 8%;
  height: 0.2rem;
  background-color: ${ColorsMap.textDefault};
  transition: all 1s ease;
  cursor: pointer;
  opacity: ${(props) => (props.activeSlide ? '1' : '0.2')};
`

export const SalePriceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Cross = styled.div`
  text-decoration: line-through;
  display: flex;
  align-items: center;
  color: ${ColorsMap.textDefault};
`
